import React,{ useContext} from "react";
import DashBoardStyle from "./DashBoardStyle.module.css";
import {AuthContext} from '../../../context/AuthContextProvider'
import { Link } from "react-router-dom";
const DashBoard = () => {
  const authContext= useContext(AuthContext)
  return (
    <>
    <h2 style={{marginTop:'10px', textAlign: "center" ,color:'#f9f9f9'}}>داشبورد</h2>
    {authContext.isAuth ? <div className={DashBoardStyle.Container}>
      
      <div className={DashBoardStyle.items}>کیف پول</div>
      <div className={DashBoardStyle.items}>سبد خرید</div>
      <div className={DashBoardStyle.items}>دوره های خریداری شده</div>
      <div className={DashBoardStyle.items}>دوره های موجود</div>
    </div> : <h3 style={{marginTop:"100px"}}><Link style={{ fontSize:"22px"}} to='/Login'>لطفا وارد حسابتان شوید</Link></h3>}
   </>
  );
};

export default DashBoard;
